module.exports = __webpack_public_path__ + "static/media/wine-glass-alt.9b8841f5.svg";